// Common boilerplate for components using a FDT as their core
export default {
  props: {
    title: {
      type: String,
      required: false,
      default: ``,
    },
    icon: {
      type: String,
      required: false,
      default: `fa fa-table`,
    },
    portletExpanded: {
      type: Boolean,
      required: false,
      default: true,
    },
    portletLocked: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
